import {
  Badge,
  Box,
  Card,
  createTheme,
  Divider,
  IconButton,
  Stack,
  Tab,
  Tabs,
  ThemeProvider,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DataGrid, GridColDef, ruRU } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import BoltIcon from '@mui/icons-material/Bolt';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { getDefaultAlertProps, getRoot } from '../../utils/utils';
import {
  ACCESS_TOKEN_NAME,
  API_STATUS_PROBLEM,
  MAIN_COLOR_STRING,
  MAIN_TITLE_FONTSIZE_STRING,
  ROOT_ADMIN_VALUE,
  ROOT_CUSTOMER_VALUE,
  ROOT_WORKER_VALUE,
} from '../../_constant/constants';
import { AlertSeverityEnum } from '../../_enum/AlertSeverityEnum';
import { IAlertProps } from '../../_interface/IAlertProps';
import { IApiResult } from '../../_interface/IApiResult';
import { MyAlert } from '../UI/MyAlert';
import { MyButton } from '../UI/MyButton';
import { RequestDto } from '../../_dto/_request/RequestDto';
import { DialogRequestCreate } from '../dialog/request/DialogRequestCreate';
import { apiDeleteRequest } from '../../services/request/apiDeleteRequest';
import { RequestDeleteDto } from '../../_dto/_request/RequestDeleteDto';
import { apiGetRequest } from '../../services/request/apiGetRequest.';
import { ContractStageEnum } from '../../_enum/ContractStageEnum';
import { DialogMoreInfo } from '../dialog/request/DialogMoreInfo';
import { apiChangeStage } from '../../services/request/apiChangeStage';
import { RequestChangeStage } from '../../_dto/_request/RequestChangeStage';
import { DialogDocumentAdd } from '../dialog/document/DialogDocumentAdd';
import { ContractDocumentType } from '../../_enum/ContractDocumentType';
import { apiChangeStageWorker } from '../../services/contract/apiChangeStageWorker';
import { DialogChat } from '../dialog/chat/DialogChat';
import { DialogConfirmation } from '../dialog/DialogConfirmation';
import { WorkTypeEnum } from '../../_enum/WorkTypeEnum';
import { DialogConfirmationCustom } from '../dialog/DialogConfirmationCustom';
import { ReestrDto } from '../../_dto/_reestr/ReestrDto';
import { DialogReestrMoreInfo } from '../dialog/reestr/DialogReestrMoreInfo';
import { apiGetReestrRequest } from '../../services/reestr/apiGetReestrRequest';
import { ReestrChangeWorkerDto } from '../../_dto/_reestr/ReestrChangeWorkerDto';
import { apiChangeWorkerReestr } from '../../services/reestr/apiChangeWorkerReestr';
import { SIGN_IN_ROUTE } from '../../_constant/routes';

export const RequestDiv = () => {
  const root = getRoot();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogReestr, setOpenDialogReestr] = useState(false);
  const [message, setMessage] = useState('');
  const [openDialogChat, setOpenDialogChat] = useState(false);
  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const [openDialogAddFile, setOpenDialogAddFile] = useState(false);
  const [openConfirmationCheck, setOpenConfirmationCheck] = useState(false);
  const [openConfirmationBack, setOpenConfirmationBack] = useState(false);
  const [openConfirmationSend, setOpenConfirmationSend] = useState(false);
  const [openConfirmationSendReestr, setOpenConfirmationSendReestr] =
    useState(false);
  const [contractDto, setContractDto] = useState<RequestDto>({
    id: -1,
    customerId: -1,
    workerId: -1,
    contractNum: '',
    subject: '',
    koeff: 1,
    cost: '',
    objectName: '',
    workType: -1,
    createdDate: '',
    modificationDate: '',
    contractStage: -1,
    workStart: '',
    workEnd: '',
    note: '',
    isMain: -1,
    organization: '',
    hasDocument0: -1,
    hasDocument1: -1,
    hasContract: -1,
    subjectCnt: -1,
    workCnt: -1,
    customerName: '',
    workPeriod: '',
    addToContract: -1,
    customerContractId: -1,
    customerContractName: '',
    messageToCustomer: -1,
    messageToWorker: -1,
    hopeDate: '',
    isPaymentCreate: -1,
    regNum: '',
    regionNum: '',
    address: '',
    region: '',
    regDate: '',
    isOpenRegion: 0,
    isPaymentDocCreate: -1,
  });
  const [reestrDto, setReestrDto] = useState<ReestrDto>({
    id: -1,
    regNum: '',
    workType: -1,
    workerId: -1,
    subject: '',
    cost: -1,
    customer: '',
    customerContract: '',
    customerId: -1,
    customerContractId: -1,
    isCrmMetrolog: -1,
    contractNum: '',
    createdDate: '',
    modificationDate: '',
    organization: '',
    region: '',
    isPaymentCreate: -1,
    regionNum: '',
    reportType: -1,
    reportNum: '',
    reportDate: '',
    objectName: '',
    address: '',
    regDate: '',
    workStage: -1,
    sendNum: '',
    sendDate: '',
    note: '',
    period: -1,
    periodBegin: -1,
    contractDate: '',
    dateType: -1,
    workStart: '',
    workEnd: '',
    koeff: 1,
    isOpenRegion: 0,
    isPaymentDocCreate: -1,
  });
  const [reestrDtos, setReestrDtos] = useState<ReestrDto[]>([]);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [contractDtos, setContractDtos] = useState<RequestDto[]>([]);
  const [openDialogConfirmation, setOpenDialogConfirmation] = useState(false);

  const getContract = async () => {
    const apiResult: IApiResult = await apiGetRequest();
    if (apiResult.isSuccess) {
      setContractDtos(apiResult.data.request);
    } else if (
      apiResult.status === 401 ||
      localStorage.getItem(ACCESS_TOKEN_NAME) === null
    ) {
      navigate(SIGN_IN_ROUTE);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const getReestr = async () => {
    const apiResult: IApiResult = await apiGetReestrRequest();
    if (apiResult.isSuccess) {
      setReestrDtos(apiResult.data.reestr);
    } else if (
      apiResult.status === 401 ||
      localStorage.getItem(ACCESS_TOKEN_NAME) === null
    ) {
      navigate(SIGN_IN_ROUTE);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const [valueTabNew, setValueTabNew] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabNew(newValue);
  };

  useEffect(() => {
    if (
      !openDialog &&
      !openDialogReestr &&
      !openDialogCreate &&
      !openDialogAddFile &&
      !openDialogChat
    ) {
      if (valueTabNew === 0) {
        getContract();
      }
      if (valueTabNew === 1) {
        getReestr();
      }
    }
  }, [
    openDialog,
    openDialogReestr,
    openDialogCreate,
    openDialogAddFile,
    openDialogChat,
    valueTabNew,
  ]);

  const deleteRequest = async (confirm: boolean) => {
    if (!confirm) {
      setOpenDialogConfirmation(false);
      return;
    }
    const deleteDto: RequestDeleteDto = {
      contractId: contractDto.id,
    };
    const apiResult: IApiResult = await apiDeleteRequest(deleteDto);
    if (apiResult.isSuccess) {
      await getContract();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setOpenDialogConfirmation(false);
  };

  const confirmDelete = (dto: RequestDto) => {
    setContractDto(dto);
    setOpenDialogConfirmation(true);
  };

  const changeStage = async (confirm: boolean) => {
    if (!confirm) {
      setOpenConfirmationCheck(false);
      return;
    }
    const changeStageDto: RequestChangeStage = {
      contractId: contractDto.id,
      contractStage: 0,
    };
    const apiResult: IApiResult = await apiChangeStage(changeStageDto);
    if (apiResult.isSuccess) {
      await getContract();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setOpenConfirmationCheck(false);
  };

  const changeStageWorker = async (confirm: boolean) => {
    if (!confirm) {
      setOpenConfirmationSend(false);
      return;
    }
    const changeStageDto: RequestChangeStage = {
      contractId: contractDto.id,
      contractStage: 2,
    };
    const apiResult: IApiResult = await apiChangeStageWorker(changeStageDto);
    if (apiResult.isSuccess) {
      await getContract();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setOpenConfirmationSend(false);
  };

  const changeStageWorkerReestr = async (confirm: boolean) => {
    if (!confirm) {
      setOpenConfirmationSendReestr(false);
      return;
    }
    const changeStageDto: ReestrChangeWorkerDto = {
      reestrId: reestrDto.id,
    };
    const apiResult: IApiResult = await apiChangeWorkerReestr(changeStageDto);
    if (apiResult.isSuccess) {
      await getReestr();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setOpenConfirmationSendReestr(false);
  };

  const changeStageToLoadDocument = async (confirm: boolean) => {
    if (!confirm) {
      setOpenConfirmationBack(false);
      return;
    }
    const changeStageDto: RequestChangeStage = {
      contractId: contractDto.id,
      contractStage: 6,
    };
    const apiResult: IApiResult = await apiChangeStage(changeStageDto);
    if (apiResult.isSuccess) {
      await getContract();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setOpenConfirmationBack(false);
  };

  const getMoreInformation = (dto: RequestDto) => {
    setContractDto(dto);
    setOpenDialog(true);
  };

  const sendToCheck = (dto: RequestDto) => {
    if (dto.hasDocument0 === 0) {
      setAlertProps({
        message: 'Сначала загрузите исходную информацию',
        severity: AlertSeverityEnum.info,
      });
      return;
    }
    setContractDto(dto);
    setMessage(
      'Вы собираетесь отправить заявку на рассмотрение. Если все данные заполнены верно, то нажмите продолжить'
    );
    setOpenConfirmationCheck(true);
  };

  const sendToWork = (dto: RequestDto) => {
    setContractDto(dto);
    setMessage(
      'Вы собираетесь взять заявку в работу. Если уверены, то нажмите продолжить'
    );
    setOpenConfirmationSend(true);
  };

  const sendToLoadDocument = (dto: RequestDto) => {
    setContractDto(dto);
    setMessage(
      'Вы собираетесь вернуть заявку на доработку. Если уверены, то нажмите продолжить'
    );
    setOpenConfirmationBack(true);
  };

  const openAddDocument = (dto: RequestDto) => {
    setContractDto(dto);
    setOpenDialogAddFile(true);
  };

  const openChat = (dto: RequestDto) => {
    setContractDto(dto);
    setOpenDialogChat(true);
  };

  const sendToWorkReestr = (dto: ReestrDto) => {
    setReestrDto(dto);
    setMessage(
      'Вы собираетесь взять заявку в работу. Если уверены, то нажмите продолжить'
    );
    setOpenConfirmationSendReestr(true);
  };

  const getMoreInformationReestr = (dto: ReestrDto) => {
    setReestrDto(dto);
    setOpenDialogReestr(true);
  };

  const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    ruRU
  );

  const columns: GridColDef[] = [
    {
      field: 'koeff',
      width: 70,
      headerName: '',
      editable: false,
      disableColumnMenu: true,
      renderCell: (row) => (
        <Stack
          width="100%"
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <BoltIcon
            fontSize="medium"
            sx={{ color: row.row.koeff !== 1 ? 'orange' : 'grey' }}
          />
          <CurrencyRubleIcon
            fontSize="medium"
            sx={{ color: row.row.isPaymentCreate === 1 ? 'purple' : 'grey' }}
          />
        </Stack>
      ),
    },
    {
      field: 'contractNum',
      renderHeader: () => <strong>Номер заявки</strong>,
      headerName: '',
      width: 200,
      editable: false,
    },
    {
      field: 'customerName',
      renderHeader: () => <strong>Филиал</strong>,
      width: 250,
      editable: false,
      hide: root === ROOT_CUSTOMER_VALUE,
    },
    {
      field: 'workType',
      width: 250,
      renderHeader: () => <strong>Тип работы</strong>,
      editable: false,
      renderCell: (row) => WorkTypeEnum[row.row.workType],
    },
    {
      field: 'subject',
      flex: 1,
      minWidth: 300,
      renderHeader: () => <strong>Предмет</strong>,
      editable: false,
    },
    {
      field: 'objectName',
      flex: 1,
      minWidth: 300,
      renderHeader: () => <strong>Объект</strong>,
      editable: false,
      renderCell: (row) => row.row.objectName.replaceAll('_', '"'),
    },
    {
      field: 'contractStage',
      width: 200,
      renderHeader: () => <strong>Статус</strong>,
      editable: false,
      hide: root !== ROOT_CUSTOMER_VALUE,
      renderCell: (row) => ContractStageEnum[row.row.contractStage],
    },
    {
      field: 'id',
      type: 'actions',
      headerName: '',
      width: root !== ROOT_WORKER_VALUE ? 175 : 140,
      editable: false,
      sortable: false,
      filterable: false,
      renderCell: (row) => (
        <Stack direction="row" width="100%" justifyContent="center">
          <IconButton
            title="Просмотр информации"
            size="small"
            onClick={() => getMoreInformation(row.row)}
          >
            <FindInPageIcon
              fontSize="small"
              sx={{ color: MAIN_COLOR_STRING }}
            />
          </IconButton>
          {root === ROOT_CUSTOMER_VALUE && (
            <IconButton
              title="Загрузка исходной информации"
              size="small"
              onClick={() =>
                row.row.contractStage === 6
                  ? openAddDocument(row.row)
                  : undefined
              }
            >
              <FileUploadIcon
                fontSize="small"
                sx={{ color: row.row.contractStage === 6 ? 'orange' : 'grey' }}
              />
            </IconButton>
          )}
          <IconButton
            size="small"
            title="Чат"
            onClick={() => openChat(row.row)}
          >
            <Badge
              color="secondary"
              variant={
                (root === ROOT_CUSTOMER_VALUE &&
                  row.row.messageToCustomer === 1) ||
                (root !== ROOT_CUSTOMER_VALUE && row.row.messageToWorker === 1)
                  ? 'dot'
                  : 'standard'
              }
            >
              <MailOutlineIcon fontSize="small" sx={{ color: 'purple' }} />
            </Badge>
          </IconButton>
          {(root === ROOT_ADMIN_VALUE || root === ROOT_WORKER_VALUE) && (
            <IconButton
              title="Не хватает документов"
              size="small"
              onClick={() =>
                row.row.contractStage === 0
                  ? sendToLoadDocument(row.row)
                  : undefined
              }
            >
              <ArrowBackIcon
                fontSize="small"
                sx={{ color: row.row.contractStage === 0 ? 'red' : 'grey' }}
              />
            </IconButton>
          )}
          {root === ROOT_CUSTOMER_VALUE && (
            <IconButton
              title="Отправить на рассмотрение"
              size="small"
              onClick={() =>
                row.row.contractStage === 6 ? sendToCheck(row.row) : undefined
              }
            >
              <ArrowForwardIcon
                fontSize="small"
                sx={{ color: row.row.contractStage === 6 ? 'blue' : 'grey' }}
              />
            </IconButton>
          )}
          {(root === ROOT_ADMIN_VALUE || root === ROOT_WORKER_VALUE) && (
            <IconButton
              title="Начать работу"
              size="small"
              onClick={() =>
                row.row.contractStage === 0 ? sendToWork(row.row) : undefined
              }
            >
              <ArrowForwardIcon
                fontSize="small"
                sx={{ color: row.row.contractStage === 0 ? 'blue' : 'grey' }}
              />
            </IconButton>
          )}
          {root !== ROOT_WORKER_VALUE && (
            <IconButton
              title="Удалить"
              size="small"
              onClick={() => confirmDelete(row.row)}
            >
              <DeleteForeverIcon fontSize="small" sx={{ color: 'red' }} />
            </IconButton>
          )}
        </Stack>
      ),
    },
  ];

  const columnsReestr: GridColDef[] = [
    {
      field: 'koeff',
      width: 70,
      headerName: '',
      editable: false,
      disableColumnMenu: true,
      renderCell: (row) => (
        <Stack
          width="100%"
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <BoltIcon
            fontSize="medium"
            sx={{ color: row.row.koeff !== 1 ? 'orange' : 'grey' }}
          />
          <CurrencyRubleIcon
            fontSize="medium"
            sx={{ color: row.row.isPaymentCreate === 1 ? 'purple' : 'grey' }}
          />
        </Stack>
      ),
    },
    {
      field: 'workType',
      renderHeader: () => <strong>Тип работы</strong>,
      width: 350,
      editable: false,
      renderCell: (row) => WorkTypeEnum[row.row.workType],
    },
    {
      field: 'subject',
      minWidth: 350,
      flex: 1,
      renderHeader: () => <strong>Предмет</strong>,
      editable: false,
    },
    {
      field: 'objectName',
      renderHeader: () => <strong>Объект</strong>,
      flex: 1,
      minWidth: 300,
      editable: false,
      renderCell: (row) => row.row.objectName.replaceAll('_', '"'),
    },
    {
      field: 'id',
      type: 'actions',
      headerName: '',
      width: 70,
      editable: false,
      sortable: false,
      filterable: false,
      renderCell: (row) => (
        <Stack direction="row" width="100%" justifyContent="center">
          <IconButton
            title="Просмотр информации"
            size="small"
            onClick={() => getMoreInformationReestr(row.row)}
          >
            <FindInPageIcon
              fontSize="small"
              sx={{ color: MAIN_COLOR_STRING }}
            />
          </IconButton>
          <IconButton
            title="Взять в работу"
            size="small"
            onClick={() => sendToWorkReestr(row.row)}
          >
            <ArrowForwardIcon fontSize="small" sx={{ color: 'blue' }} />
          </IconButton>
        </Stack>
      ),
    },
  ];

  const other = {
    autoHeight: true,
    showCellRightBorder: true,
    showColumnRightBorder: true,
  };

  return (
    <Stack width="100%" alignItems="center" justifyContent="center">
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Card style={{ padding: '40px', width: '90%', marginTop: '40px' }}>
        <Stack width="100%" spacing={2}>
          <Stack
            alignItems="center"
            justifyContent="space-between"
            direction="row"
            spacing={1}
          >
            <Typography
              style={{
                fontFamily: 'SF Compact Rounded',
                fontStyle: 'normal',
                fontWeight: 600,
                fontSize: MAIN_TITLE_FONTSIZE_STRING,
                letterSpacing: 1,
                color: '#000000',
              }}
              component="text"
            >
              {root === ROOT_CUSTOMER_VALUE
                ? 'Заявки'
                : 'Заявки на рассмотрении'}
            </Typography>
            {root === ROOT_CUSTOMER_VALUE && (
              <MyButton
                text="Создать"
                width="100px"
                height="30px"
                background={MAIN_COLOR_STRING}
                onClick={() => setOpenDialogCreate(true)}
              />
            )}
            {root !== ROOT_CUSTOMER_VALUE && (
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  value={valueTabNew}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Филиалы" />
                  <Tab label="Прямые договора" />
                </Tabs>
              </Box>
            )}
          </Stack>
          <Divider />
          <div>
            {valueTabNew === 0 && (
              <Box sx={{ width: '100%' }}>
                <ThemeProvider theme={theme}>
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                        py: 1,
                      },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                        py: '5px',
                      },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell':
                        {
                          py: '10px',
                        },
                      '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus-within':
                        {
                          outline: 'none !important',
                        },
                    }}
                    getRowHeight={() => 'auto'}
                    columns={columns}
                    rows={contractDtos}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...other}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                  />
                </ThemeProvider>
              </Box>
            )}
            {valueTabNew === 1 && (
              <Box sx={{ width: '100%' }}>
                <ThemeProvider theme={theme}>
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                        py: 1,
                      },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                        py: '5px',
                      },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell':
                        {
                          py: '10px',
                        },
                      '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus-within':
                        {
                          outline: 'none !important',
                        },
                    }}
                    getRowHeight={() => 'auto'}
                    columns={columnsReestr}
                    rows={reestrDtos}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...other}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                  />
                </ThemeProvider>
              </Box>
            )}
          </div>
        </Stack>
      </Card>
      <DialogChat
        open={openDialogChat}
        idContract={contractDto.id}
        onClose={() => setOpenDialogChat(false)}
      />
      <DialogRequestCreate
        open={openDialogCreate}
        onClose={() => setOpenDialogCreate(false)}
      />
      <DialogDocumentAdd
        open={openDialogAddFile}
        name="Исходная информация"
        type={ContractDocumentType.INFO}
        dto={contractDto}
        onClose={() => setOpenDialogAddFile(false)}
      />
      <DialogMoreInfo
        open={openDialog}
        dto={contractDto}
        onClose={() => setOpenDialog(false)}
      />
      <DialogReestrMoreInfo
        open={openDialogReestr}
        dto={reestrDto}
        onClose={() => setOpenDialogReestr(false)}
      />
      <DialogConfirmation
        open={openDialogConfirmation}
        onClose={deleteRequest}
      />
      <DialogConfirmationCustom
        open={openConfirmationCheck}
        message={message}
        onClose={changeStage}
      />
      <DialogConfirmationCustom
        open={openConfirmationSend}
        message={message}
        onClose={changeStageWorker}
      />
      <DialogConfirmationCustom
        open={openConfirmationBack}
        message={message}
        onClose={changeStageToLoadDocument}
      />
      <DialogConfirmationCustom
        open={openConfirmationSendReestr}
        message={message}
        onClose={changeStageWorkerReestr}
      />
    </Stack>
  );
};
